export interface IInvite {
  id: string;
  subscriptionId: string;
  subscriptionSystem: string;
  mainBrand: string;
  email: string;
  roleName: string;
  createdAt: string;
  expirationDate: string;
  status: string;
  acceptedBy?: string;
}

export enum INVITE_FIELDS {
  ID = 'id',
  EMAIL = 'email',
  ROLE_NAME = 'roleName',
  CREATED_AT = 'createdAt',
  EXPIRATION_DATE = 'expirationDate',
  STATUS = 'status',
  ACCEPTED_BY = 'acceptedBy',
}
